var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { r as registerInstance, c as createEvent, h, H as Host, g as getElement } from './core-6f498fd9.js';
var CsmSwitcher = /** @class */ (function () {
    function CsmSwitcher(hostRef) {
        registerInstance(this, hostRef);
        this.host.addEventListener('csmClick', this.onSelect.bind(this));
        this.csmChange = createEvent(this, "csmChange", 7);
    }
    CsmSwitcher.prototype.onSelect = function (e) {
        if (this.selectedItem) {
            this.selectedItem.selected = false;
        }
        if (e.detail) {
            var _a = e.detail, host = _a.host, value = _a.value;
            this.value = value;
            this.selectedItem = host;
            this.selectedItem.selected = true;
            this.csmChange.emit(value);
        }
    };
    CsmSwitcher.prototype.componentWillLoad = function () {
        var options = __spreadArrays(this.host.querySelectorAll('csm-switcher-option'));
        this.selectedItem = options.find(function (item) { return item.selected; });
        this.value = this.selectedItem && this.selectedItem.value;
    };
    CsmSwitcher.prototype.render = function () {
        return (h(Host, null, h("slot", null)));
    };
    Object.defineProperty(CsmSwitcher.prototype, "host", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSwitcher, "style", {
        get: function () { return "\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:400;src:url(../assets/fonts/ProximaNova-Regular.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Regular.woff) format(\"woff\")}\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:600;src:url(../assets/fonts/ProximaNova-Semibold.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Semibold.woff) format(\"woff\")}\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:700;src:url(../assets/fonts/ProximaNova-Semibold.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Semibold.woff) format(\"woff\")}\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:900;src:url(../assets/fonts/ProximaNova-Black.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Black.woff) format(\"woff\")}\@font-face{font-family:CS-FontIcon-v19;src:url(../assets/icons/CS-FontIcon-v19.eot?cz1hbb);src:url(../assets/icons/CS-FontIcon-v19.eot?cz1hbb#iefix) format(\"embedded-opentype\"),url(../assets/icons/CS-FontIcon-v19.ttf?cz1hbb) format(\"truetype\"),url(../assets/icons/CS-FontIcon-v19.woff?cz1hbb) format(\"woff\"),url(../assets/icons/CS-FontIcon-v19.svg?cz1hbb#CS-FontIcon-v18) format(\"svg\");font-weight:400;font-style:normal;font-display:block}:root{font-family:Proxima Nova,sans-serif}*,:after,:before{font-family:inherit}*,:after,:before,:host{-webkit-box-sizing:border-box;box-sizing:border-box}:host{display:-ms-flexbox;display:flex;height:32px;-ms-flex-wrap:nowrap;flex-wrap:nowrap;overflow:hidden}"; },
        enumerable: true,
        configurable: true
    });
    return CsmSwitcher;
}());
export { CsmSwitcher as csm_switcher };
